export default "__VITE_ASSET__2b7419db__"